import Medal from './Medal'
import MedalModal from './MedalModal'
import MedalP from './MedalP'


export {
    Medal,
    MedalModal,
    MedalP,
}


// WEBPACK FOOTER //
// ./src/components/medal/index.js